export const SocialData=[
    {
        platform:"Github",
        icon: require("../../assets/icons/github.png"),
        link:"https://github.com/Abhishek2000Singh",
    },
    {
        platform:"Linkedin",
        icon: require("../../assets/icons/linkdein.avif"),
        link:"https://www.linkedin.com/in/abhishek-singh-854675207/",
    },
    {
        platform:"Twitter",
        icon: require("../../assets/icons/twitter.webp"),
        link: "https://twitter.com/Abhishe89364466",
    },
    {
        platform:"Leetcode",
        icon: require("../../assets/icons/leetcode.png"),
        link:"https://leetcode.com/Abhishek_Singh2000/",
    },
    // {
    //     platform:"Replit",
    //     icon: require("../../assets/icons/replit.png"),
    //     link:"https://replit.com/@VIMALANAND",
    // },
    // {
    //     platform:"Linktree",
    //     icon: require("../../assets/icons/linktree.png"),
    //     link:"https://linktr.ee/vimalanand_07",
    // },
];